import { render } from "./CustomObject.vue?vue&type=template&id=263084d2"
import script from "./CustomObject.vue?vue&type=script&lang=js"
export * from "./CustomObject.vue?vue&type=script&lang=js"
script.render = render

export default script